import { BookAlert, ChevronRight, Info, ShieldUser } from 'lucide-react';
import UDLink from 'modules/ud-ui/components/link';
import React, { useEffect } from 'react';

import UDHeaderTitle from 'ud-ui/components/header-title';
import { useMainLayout } from 'ud-ui/layout/main/context';

const links = [
  {
    href: 'https://imgameapp.ru/#organizer',
    label: 'О приложении',
    icon: <Info size={20} />,
  },
  {
    href: 'https://imgameapp.ru/privacy-policy',
    label: 'Политика конфиденциальности',
    icon: <BookAlert size={20} />,
  },
  {
    href: 'https://imgameapp.ru/terms-and-conditions',
    label: 'Условия использования',
    icon: <ShieldUser size={20} />,
  },
];

const AboutPage: React.FC = () => {
  const { setHeaderContent } = useMainLayout();

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>О приложении</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <div className="w-full px-6 py-6">
      <div className="flex flex-col gap-3">
        {links.map(({ href, label, icon }) => (
          <UDLink
            key={href}
            to={href}
            target="_blank"
            rel="noreferrer"
            className="dark-blue flex items-center gap-3 rounded-lg bg-white px-5 py-0 no-underline"
            style={{ height: 72, minHeight: 72 }}
          >
            {icon}
            <span className="flex-1">{label}</span>
            <ChevronRight size={20} className="color-gray" style={{ opacity: 0.4 }} />
          </UDLink>
        ))}
      </div>
    </div>
  );
};

export default AboutPage;
